import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, withDefaults } from 'vue'

type PropsType = {
  modelValue?: boolean
  disabled?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SimpleSwitch',
  props: {
    modelValue: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
  },
  emits: ["update:modelValue", "change"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:modelValue', value: boolean): void
  (e: 'change', value: boolean): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { modelValue: boolean, disabled: boolean };





const internalValue = computed({
  get: () => props.modelValue,
  set: (value) => {
    emit('update:modelValue', value)
    // TODO 親コンポーネントで'update:modelValue'を利用すればchangeは不要だが、利用しているコンポーネントの修正がなるべく発生しないように2重でchangeイベントを追加している。
    emit('change', value)
  },
})

return (_ctx: any,_cache: any) => {
  const _component_el_switch = _resolveComponent("el-switch")!

  return (_openBlock(), _createBlock(_component_el_switch, {
    modelValue: _unref(internalValue),
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(internalValue) ? (internalValue).value = $event : null)),
    "active-color": "#54c1e3",
    "inactive-color": "#737689",
    disabled: __props.disabled
  }, null, 8, ["modelValue", "disabled"]))
}
}

})